var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#fff",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M17.626 5.4H6.375a.974.974 0 0 0-.975.974v11.251a.974.974 0 0 0 .975.975h11.251a.975.975 0 0 0 .974-.975V6.375a.975.975 0 0 0-.974-.975M9.335 16.645H7.35V10.34h1.985zM8.34 9.467A1.14 1.14 0 1 1 9.487 8.33 1.123 1.123 0 0 1 8.34 9.467m8.309 7.183h-1.984v-3.444c0-1.015-.432-1.329-.989-1.329-.588 0-1.166.444-1.166 1.355v3.418h-1.985v-6.305h1.909v.874h.026c.191-.388.862-1.05 1.886-1.05 1.107 0 2.304.657 2.304 2.582z"
})));
export default SvgLinkedin;